import {registerLocaleData} from '@angular/common'
import {provideHttpClient, withFetch, withInterceptors} from '@angular/common/http'
import localeFr from '@angular/common/locales/fr'
import {ApplicationConfig, inject, LOCALE_ID, provideAppInitializer, provideZoneChangeDetection} from '@angular/core'
import {MAT_CARD_CONFIG} from '@angular/material/card'
import {MAT_DATE_LOCALE, provideNativeDateAdapter} from '@angular/material/core'
import {MAT_FORM_FIELD_DEFAULT_OPTIONS} from '@angular/material/form-field'
import {provideRouter, withComponentInputBinding, withHashLocation, withInMemoryScrolling} from '@angular/router'
import {routes} from './app.routes'
import {LOCAL_STORAGE, WINDOW} from './application/app'
import {authInterceptor} from './application/auth.interceptor'
import {ConfigService} from './services/config.service'
import {responseInterceptor} from '@sparbanken-syd/sparbanken-syd-bankid'

registerLocaleData(localeFr, 'fr')

export const appConfig: ApplicationConfig = {
  providers: [
    provideAppInitializer(() => {
      const localStorage = inject(LOCAL_STORAGE)
      inject(ConfigService).bootstrap(localStorage)
    }),
    {provide: MAT_CARD_CONFIG, useValue: {appearance: 'outlined'}},
    {provide: WINDOW, useValue: globalThis},
    {
      provide: LOCAL_STORAGE,
      useFactory: () => localStorage
    },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        subscriptSizing: 'dynamic',
        floatLabel: 'always',
        hideRequiredMarker: true,
        appearance: 'outline'
      }
    },
    {provide: MAT_DATE_LOCALE, useValue: 'sv-SE'},
    {provide: LOCALE_ID, useValue: 'fr'},
    provideNativeDateAdapter(),
    provideZoneChangeDetection({eventCoalescing: true}),
    provideRouter(routes,
      withComponentInputBinding(),
      withHashLocation(), withInMemoryScrolling({anchorScrolling: 'enabled'})),
    provideHttpClient(
      withFetch(),
      withInterceptors([
        authInterceptor,
        responseInterceptor
      ])
    )
  ]
}